import styled, { css, keyframes } from 'styled-components';

import { phone, phoneMax } from "../../Styles/MediaQueries";
import { HEX, RGB } from "../../Styles/LegacyColors";
import { commonResets } from "../../Styles/Utils";

// TO DO: Align and extract these to theme. (WP-254)
// TO DO: Extract styles from _commonStyles to packages/styles (WP-255)

const easeAnimation = /*#__PURE__*/css(["transition:all 0.15s ease;"]);



const spin = /*#__PURE__*/keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);








export const Button = /*#__PURE__*/styled.button.withConfig({ displayName: "styles__Button", componentId: "sc-g9nhz3-0" })(["", " & *,&:before,&:after,& *:before,& *:after{", "}display:inline-block;cursor:pointer;position:relative;background:none;&:before{", " border:3px solid ", ";border-top:3px solid ", ";border-radius:50%;width:30px;height:30px;animation:", " 2s linear infinite;position:absolute;top:50%;left:50%;margin:-15px 0 0 -15px;content:' ';display:block;opacity:0;visibility:hidden;}", " ", " ", " ", ""],






commonResets,





commonResets,








easeAnimation,

HEX.lightGrey,
HEX.blue,



spin,












(props) =>
props.isLoading &&
css(["cursor:not-allowed;&:before{opacity:1;visibility:visible;}"]),








(props) =>
props.centred &&
css(["width:100%;display:block;text-align:center;"]),





(props) =>
props.fullWidth &&
css(["width:100%;"]),



(props) =>
props.disabled &&
css(["opacity:0.5;cursor:not-allowed;"]));





export const Wrap = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Wrap", componentId: "sc-g9nhz3-1" })(["", " position:relative;font-size:14px;line-height:1.45;font-weight:700;min-height:45px;display:flex;align-items:center;text-transform:uppercase;border-radius:100px;padding:10px 20px;color:", ";border:2px solid ", ";background-color:transparent;", ":hover &&{background-color:rgba(", ",0.1);}", ":active &&{background-color:rgba(", ",0.15);}", " ", " ", " ", " ", " ", " ", " ", " ", " @media ", " and ", "{font-size:12px;}"],











easeAnimation,













HEX.darkGrey,
HEX.darkGrey,


/* sc-selector */Button,
RGB.darkGrey,


/* sc-selector */Button,
RGB.darkGrey,


(props) =>
props.primary &&
css(["color:", ";border-color:", ";background-color:", ";", ":hover &&{background-color:rgba(", ",0.8);}", ":active &&{border-color:", ";background-color:", ";}"],
HEX.white,
HEX.purple,
HEX.purple,
Button,
RGB.purple,


Button,
HEX.brightPurple,
HEX.brightPurple),



(props) =>
props.primaryOutline &&
css(["color:", ";border:2px solid ", ";background-color:transparent;", ":hover &&{background-color:rgba(", ",0.1);}", ":active &&{color:", ";border-color:", ";background-color:rgba(", ",0.15);}"],
HEX.purple,
HEX.purple,

Button,
RGB.purple,


Button,
RGB.brightPurple,
RGB.brightPurple,
RGB.purple),



(props) =>
props.small &&
css(["min-height:30px;padding-top:5px;padding-bottom:5px;font-size:12px;"]),






(props) =>
(props.arrow || props.arrowWhite) &&
css(["padding-right:50px;"]),



(props) =>
props.arrow &&
css(["padding-right:50px;"]),



(props) =>
props.white &&
css(["color:", ";border:2px solid ", ";background-color:transparent;", ":hover &&{background-color:rgba(", ",0.1);}", ":active &&{background-color:rgba(", ",0.15);}"],
HEX.white,
HEX.white,


Button,
RGB.white,

Button,
RGB.white),



(props) =>
props.isLoading &&
css(["", " &&{opacity:0.5;}"],
Button),




(props) =>
props.centred &&
css(["", " &&{display:inline-block;}"],
Button),




(props) =>
props.fullWidth &&
css(["", " &&{display:block;}"],
Button),




phone, phoneMax);




export const Arrow = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Arrow", componentId: "sc-g9nhz3-2" })(["", " display:none;width:20px;height:100%;position:absolute;top:0;right:20px;background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='11px' height='18px' viewBox='0 0 11 18' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 44.1 (41455) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EPage 1%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Final-' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Halo-Desktop' transform='translate(-570.000000, -6251.000000)' fill='%23333'%3E%3Cg id='Why-Grover' transform='translate(0.000000, 5824.000000)'%3E%3Cg id='CTA-arrow-right' transform='translate(359.000000, 424.000000)'%3E%3Cg id='text-CTA'%3E%3Cpolygon id='Page-1' points='212.414 3.0001 211 4.4141 218.293 11.7071 211 19.0001 212.414 20.4141 221.122 11.7071'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");background-size:auto auto;background-position:50% 50%;background-repeat:no-repeat;transform:translate3d(0,0,0);", ":hover &&{transform:translate3d(3px,0,0);}", ":active &&{transform:translate3d(3px,0,0);}", " ", ""],
easeAnimation,















/* sc-selector */Button,



/* sc-selector */Button,



(props) =>
props.arrow &&
css(["display:block;"]),



(props) =>
props.arrowWhite &&
css(["background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='11px' height='18px' viewBox='0 0 11 18' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 44.1 (41455) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EPage 1%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Final-' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Halo-Desktop' transform='translate(-570.000000, -6251.000000)' fill='%23FFFFFF'%3E%3Cg id='Why-Grover' transform='translate(0.000000, 5824.000000)'%3E%3Cg id='CTA-arrow-right' transform='translate(359.000000, 424.000000)'%3E%3Cg id='text-CTA'%3E%3Cpolygon id='Page-1' points='212.414 3.0001 211 4.4141 218.293 11.7071 211 19.0001 212.414 20.4141 221.122 11.7071'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");display:block;"]));